import { faqThemeBodySchema } from "@redotech/redo-model/faq/faq-body-schema";
import * as z from "zod/v4";

export const getFaqTheme = {
  name: "getFaqTheme" as const,
  input: z.object({}),
  output: z.object({ theme: z.optional(faqThemeBodySchema) }),
};
